var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notFound)?_c('page-block-not-found',{attrs:{"path":_vm.renderBlock.path,"component-name":_vm.renderBlock.id}}):_c(_vm.component,_vm._b({tag:"component",attrs:{"uid":_vm.renderBlock.id}},'component',_vm.renderBlock.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }